export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.24.2';
//# sourceMappingURL=version.js.map